module.exports = __webpack_public_path__ + "static/media/lavander_4.e5a10330.png";